export default __webpack_public_path__ + "static/sx-80f00cf90ddf72e22a20e9bb902c6ca0.svg";